import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import Login from './pages/login'; 
import Dashboard from './pages/Dashboard';
import QuizPage from './pages/QuizPage';
import ExamSelection from './pages/ExamSelection';
import InstructionPage from './pages/InstructionPage';
import AdminExam from './pages/admin/AdminExam';
import AdminQuestionManager from './pages/admin/AdminQuestionManager';
import AdminQuestions from './pages/admin/AdminQuestions';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminSettings from './pages/admin/AdminSettings';
import UserManagement from './components/UserManagement';
import WritingExam from './pages/WritingExam';

function App() {
  // ✅ Check token ngay khi app load
  const token = localStorage.getItem('token');

  return (
    <Router>
      <Routes>

        {/* 1. Public */}
        <Route 
          path="/login" 
          element={token ? <Navigate to="/dashboard" replace /> : <Login />} 
        />

        <Route 
          path="/" 
          element={<Navigate to={token ? "/dashboard" : "/login"} replace />} 
        />

        {/* 2. User */}
        <Route path="/dashboard" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />

        <Route path="/select/:type" element={
          <ProtectedRoute><ExamSelection /></ProtectedRoute>
        } />

        <Route path="/instructions/:examType/:testId" element={
          <ProtectedRoute><InstructionPage /></ProtectedRoute>
        } />

        {/* Writing phải nằm trước */}
        <Route path="/quiz/writing/:testId" element={
          <ProtectedRoute><WritingExam /></ProtectedRoute>
        } />

        <Route path="/quiz/:examType/:testId" element={
          <ProtectedRoute><QuizPage /></ProtectedRoute>
        } />

        {/* 3. Admin */}
        <Route path="/admin/dashboard" element={
          <ProtectedRoute><AdminDashboard /></ProtectedRoute>
        } />

        <Route path="/admin/add-exam" element={
          <ProtectedRoute><AdminExam /></ProtectedRoute>
        } />

        <Route path="/admin/questions" element={
          <ProtectedRoute><AdminQuestionManager /></ProtectedRoute>
        } />

        <Route path="/admin/add-questions" element={
          <ProtectedRoute><AdminQuestions /></ProtectedRoute>
        } />

        <Route path="/admin/settings" element={
          <ProtectedRoute><AdminSettings /></ProtectedRoute>
        } />

        <Route path="/admin/user-management" element={
          <ProtectedRoute><UserManagement /></ProtectedRoute>
        } />

        {/* optional */}
        <Route path="/writing/:testId" element={<WritingExam />} />

        {/* 404 */}
        <Route path="*" element={
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h2>404 - Không tìm thấy trang</h2>
            <p>Vui lòng kiểm tra lại đường dẫn hoặc quay lại trang chủ.</p>
            <button onClick={() => window.location.href = '/dashboard'}>
              Quay lại Dashboard
            </button>
          </div>
        } />

      </Routes>
    </Router>
  );
}

export default App;